const API_URL = process.env.REACT_APP_BACKEND_URL;

const visitorId = () => {
  let id = localStorage.getItem('cvs_visitor');
  if (!id) {
    id = `${Date.now().toString(36)}${Math.random().toString(36).slice(2, 10)}`;
    localStorage.setItem('cvs_visitor', id);
  }
  return id;
};

export const sendGuidebookEvent = (propertyId, type, section) => {
  if (type === 'open') {
    const key = `cvs_gb_open_${propertyId}`;
    if (sessionStorage.getItem(key)) return;
    sessionStorage.setItem(key, '1');
  }
  fetch(`${API_URL}/api/public/guidebook/${propertyId}/event`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ type, section: section || null, visitor: visitorId() }),
    keepalive: true,
  }).catch(() => {});
};
